var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"ico-bt mr-2 red-bt",class:_vm.isFavourite ? 'active' : '',attrs:{"loading":_vm.isLoading},on:{"click":_vm.toggleFavourite}},[_c('b-icon',{attrs:{"icon":"heart"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }